export enum AnchorType {
  PROJECT = "PROJECT",
  FAVORITES = "FAVORITES"
}
